class MenuDrawerSearch extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.closest('.menu-drawer');
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearch = this.querySelector('predictive-search');
    this.headerClose = this.drawer?.querySelector('.menu-drawer__header-close');
  }

  connectedCallback() {
    this.onResize = this.updateHeaderHeight.bind(this);

    this.input?.addEventListener('focus', this.onSearchFocus.bind(this));
    this.addEventListener('focusout', this.onSearchFocusOut.bind(this));
    this.headerClose?.addEventListener('click', this.onHeaderCloseClick.bind(this), true);
    this.closest('details')?.addEventListener('toggle', this.onDrawerToggle.bind(this));
    window.addEventListener('resize', this.onResize);
    this.updateHeaderHeight();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  updateHeaderHeight() {
    const header = this.drawer?.querySelector('.menu-drawer__header');
    if (!header || !this.drawer) return;

    this.drawer.style.setProperty('--menu-drawer-header-height', `${header.offsetHeight}px`);
  }

  onDrawerToggle(event) {
    if (!event.currentTarget.open) {
      this.closeSearch(true);
      return;
    }

    this.updateHeaderHeight();
  }

  onSearchFocus() {
    this.drawer?.classList.add('menu-drawer--search-active');
  }

  onSearchFocusOut() {
    window.setTimeout(() => {
      if (!this.drawer?.classList.contains('menu-drawer--search-active')) return;
      if (this.contains(document.activeElement)) return;
      this.closeSearch(false);
    }, 100);
  }

  onHeaderCloseClick(event) {
    if (!this.drawer?.classList.contains('menu-drawer--search-active')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.closeSearch(true);
  }

  closeSearch(clearSearchTerm) {
    this.predictiveSearch?.close(clearSearchTerm);
    this.input?.blur();
    this.drawer?.classList.remove('menu-drawer--search-active');
  }
}

customElements.define('menu-drawer-search', MenuDrawerSearch);
